import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFolderBlocked = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.64 20.987c3.357 0 5.334-1.978 5.334-5.333L21 10.998c0-3.422-1.242-5.134-4.605-5.134h-2.653a2.15 2.15 0 0 1-1.712-.856l-.856-1.139a2.14 2.14 0 0 0-1.711-.856H7.588C4.232 3.013 3 4.99 3 8.341v7.313c0 3.355 1.981 5.333 5.345 5.333zM13.79 14.985l-3.581-3.58m0 3.58 3.581-3.58"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFolderBlocked);
export default ForwardRef;
